module.exports = __webpack_public_path__ + "img/espa_en.63118199.jpg";